module.exports = __webpack_public_path__ + "images/screen-shots/child-progress-fed0b21545906da95964d4699ff42206.png";